var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSofa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "37px",
    viewBox: "0 0 57 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sofa Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    stroke: "#000000",
    fill: "#FFFFFF",
    x: 4,
    y: 28,
    width: 4,
    height: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    stroke: "#000000",
    fill: "#FFFFFF",
    x: 49,
    y: 28,
    width: 4,
    height: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 6,
    y: 1,
    width: 45,
    height: 30,
    rx: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#000000",
    fillRule: "nonzero",
    points: "29 0 29 32 27 32 27 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 20.5,
    x2: 52.5,
    y2: 20.5,
    id: "Line-2",
    stroke: "#000000",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,14 C9.65685425,14 11,15.3431458 11,17 L11,25.5 L46,25.5 L46,17 C46,15.3431458 47.3431458,14 49,14 L53,14 C54.6568542,14 56,15.3431458 56,17 L56,30 C56,31.6568542 54.6568542,33 53,33 L49,33 C48.3875341,33 47.817935,32.8164652 47.3432015,32.5013944 L9.65679853,32.5013944 C9.18206502,32.8164652 8.61246593,33 8,33 L4,33 C2.34314575,33 1,31.6568542 1,30 L1,17 C1,15.3431458 2.34314575,14 4,14 L8,14 Z",
    id: "Combined-Shape",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa);
export default __webpack_public_path__ + "static/media/sofa.dd60b88dbc14dc4d04aef764b8f928d0.svg";
export { ForwardRef as ReactComponent };